import styles from "./DatasetSnapshots.module.scss";
import { Form, Modal } from "antd";
import { VLInput, VLTextArea } from "../../../uikit/FormFields/VLInput/VLInput";
import { DatasetSnapshotMetadata } from "../../../../vl-api/vlSchemas";
import { useSnapshotModal } from "./useSnapshotModal";

export type SnapshotModalProps = {
  datasetId: string;
  isOpen: boolean;
  close: () => void;
  snapshot?: DatasetSnapshotMetadata;
};

export const SnapshotModal = ({
  isOpen,
  close,
  snapshot,
  datasetId,
}: SnapshotModalProps) => {
  const { isLoading, submit } = useSnapshotModal({
    datasetId,
    snapshot,
    close,
  });

  return (
    <Modal
      destroyOnClose
      open={isOpen}
      onCancel={close}
      title={`${snapshot ? "Update" : "Create"} Snapshot`}
      okText={snapshot ? "Update" : "Create"}
      cancelButtonProps={{ type: "text" }}
      okButtonProps={{ loading: isLoading, form: FORM_ID, htmlType: "submit" }}
    >
      {!snapshot && (
        <div className={styles.modalSubheader}>
          Create a saved state of your dataset that you can restore later.
        </div>
      )}
      <SnapshotForm snapshot={snapshot} onSubmit={submit} />
    </Modal>
  );
};

const FORM_ID = "snapshot-form";

const SnapshotForm = ({
  snapshot,
  onSubmit,
}: {
  onSubmit: (values: any) => void;
  snapshot?: DatasetSnapshotMetadata;
}) => {
  const [form] = Form.useForm();
  return (
    <Form
      id={FORM_ID}
      className={styles.form}
      form={form}
      layout="vertical"
      onFinish={onSubmit}
      initialValues={{
        name: snapshot?.snapshot_name,
        description: snapshot?.description,
      }}
    >
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: "Cannot be empty" }]}
      >
        <VLInput placeholder="Images And Videos_snapshot_2025-12-23_16-39" />
      </Form.Item>
      <Form.Item
        name="description"
        label={
          <>
            Description <span className={styles.optional}>(optional)</span>
          </>
        }
      >
        <VLTextArea placeholder="Add a description for this snapshot" />
      </Form.Item>
    </Form>
  );
};
